import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { showAlert } from 'utility/SweetAlert'

const InteractorWarehouseDeliveryLinesPickupItem = () => {
  const deliveryLinesPickupItem = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/delivery-lines/pickup-item', payload, (response) => {
      if (response.code === 7200) {
        callback(response.data)
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
          back: true,
        })
      }
      loading(false)
    })
  }, [])
  return { deliveryLinesPickupItem }
}

export default InteractorWarehouseDeliveryLinesPickupItem
